import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../utils/mask.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <div>
                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div>
                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div>
                        <InputForm
                            label="Placa"
                            value={filters.plate}
                            mask={MaskDefault.plateNoRestrict}
                            onChange={({target}) => setFilters(prev => ({ ...prev, plate: target.value?.toUpperCase() }))}
                            instanceId="plate"
                            id="plate"
                            classNameWrapper={"w-full"}
                            autocomplete={'off'}
                        />
                    </div>

                    <div className={"ml-1"}>
                        <InputCheckbox
                            id="showDescription"
                            label="Exibir descrição"
                            checked={filters.showDescription}
                            onChange={(e) => setFilters(prev => ({...prev, showDescription: e.target.checked}))}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;